// mimic scripts/core/controller/mainController.js
// minus demo items, like chatters -> mainControllerChatters

angular.module('theme.core.main_controller', ['theme.core.services'])
  .controller('ThemeController', function($scope, ThemeService, $timeout) {
    'use strict';
    // this.layoutIsSmallScreen = false;
    this.layoutFixedHeader = ThemeService.get('fixedHeader');
    this.layoutPageTransitionStyle = ThemeService.get('pageTransitionStyle');
    this.layoutDropdownTransitionStyle = ThemeService.get('dropdownTransitionStyle');
    this.layoutPageTransitionStyleList = ['bounce',
      'flash',
      'pulse',
      'bounceIn',
      'bounceInDown',
      'bounceInLeft',
      'bounceInRight',
      'bounceInUp',
      'fadeIn',
      'fadeInDown',
      'fadeInDownBig',
      'fadeInLeft',
      'fadeInLeftBig',
      'fadeInRight',
      'fadeInRightBig',
      'fadeInUp',
      'fadeInUpBig',
      'flipInX',
      'flipInY',
      'lightSpeedIn',
      'rotateIn',
      'rotateInDownLeft',
      'rotateInDownRight',
      'rotateInUpLeft',
      'rotateInUpRight',
      'rollIn',
      'zoomIn',
      'zoomInDown',
      'zoomInLeft',
      'zoomInRight',
      'zoomInUp'
    ];

    var self = this;

    this.layoutLoading = true;
    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
		self.layoutLoading = false;
	})
    
    this.get = function(key) {
      return ThemeService.get(key);
    };

    this.setNavbarClass = function(classname, $event) {
      $event.preventDefault();
      $event.stopPropagation();
      ThemeService.set('topNavThemeClass', classname);
    };

    this.setSidebarClass = function(classname, $event) {
      $event.preventDefault();
      $event.stopPropagation();
      ThemeService.set('sidebarThemeClass', classname);
    };

	/*
    this.$watch('layoutFixedHeader', function(newVal, oldval) {
      if (newVal === undefined || newVal === oldval) {
        return;
      }
      ThemeService.set('fixedHeader', newVal);
    });
    this.$watch('layoutLayoutBoxed', function(newVal, oldval) {
      if (newVal === undefined || newVal === oldval) {
        return;
      }
      ThemeService.set('layoutBoxed', newVal);
    });
    this.$watch('layoutLayoutHorizontal', function(newVal, oldval) {
      if (newVal === undefined || newVal === oldval) {
        return;
      }
      ThemeService.set('layoutHorizontal', newVal);
    });
    this.$watch('layoutPageTransitionStyle', function(newVal) {
      ThemeService.set('pageTransitionStyle', newVal);
    });
    this.$watch('layoutDropdownTransitionStyle', function(newVal) {
      ThemeService.set('dropdownTransitionStyle', newVal);
    });
	*/
	
    this.hideHeaderBar = function() {
      ThemeService.set('headerBarHidden', true);
    };

    this.showHeaderBar = function($event) {
      $event.stopPropagation();
      ThemeService.set('headerBarHidden', false);
    };

    this.toggleLeftBar = function() {
      if (this.layoutIsSmallScreen) {
        return ThemeService.set('leftbarShown', !ThemeService.get('leftbarShown'));
      }
      ThemeService.set('leftbarCollapsed', !ThemeService.get('leftbarCollapsed'));
    };

    this.toggleRightBar = function() {
      ThemeService.set('rightbarCollapsed', !ThemeService.get('rightbarCollapsed'));
    };

    this.toggleSearchBar = function($event) {
      $event.stopPropagation();
      $event.preventDefault();
      ThemeService.set('showSmallSearchBar', !ThemeService.get('showSmallSearchBar'));
    };

    // chatters - gone

    $scope.$on('themeEvent:maxWidth767', function(event, newVal) {
      $timeout(function() {
        self.layoutIsSmallScreen = newVal;
        if (!newVal) {
          ThemeService.set('leftbarShown', false);
        } else {
          ThemeService.set('leftbarCollapsed', false);
        }
      });
    });
    $scope.$on('themeEvent:changed:fixedHeader', function(event, newVal) {
      self.layoutFixedHeader = newVal;
    });
    $scope.$on('themeEvent:changed:layoutHorizontal', function(event, newVal) {
      self.layoutLayoutHorizontal = newVal;
    });
    $scope.$on('themeEvent:changed:layoutBoxed', function(event, newVal) {
      self.layoutLayoutBoxed = newVal;
    });

    
	window.ThemeService = ThemeService;
	window.ThemeServiceCtrl = this;
    
  });